import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

export interface IFormComponent {
  validate(): boolean;
}

export interface IFormValidationError {
  [key: string]:
    | string
    | {
        required?: string;
        minlength?: string;
        maxlength?: string;
        pattern?: string;
        email?: string;
        min?: string;
        max?: string;
        nullValidator?: ''; // No error message for nullValidator
      };
}

export interface IFormControlConfig {
  name: string;
  component?: any;
  tabIndex?: number;
  styleClass?: string;
  type?: any;
  control: FormControl<any>;
  label?: string;
  help?: string;
  errors?: IFormValidationError;
}

export abstract class FormControlConfig implements IFormControlConfig {
  name: string;
  component?: any;
  tabIndex?: number;
  styleClass?: string;
  type?: any;
  control: FormControl<any>;
  label?: string;
  help?: string;
  errors?: IFormValidationError;

  constructor();
  constructor(obj: IFormControlConfig);
  constructor(obj?: IFormControlConfig) {
    this.name = obj?.name ?? '';
    this.component = obj?.component;
    this.styleClass = obj?.styleClass;
    this.tabIndex = obj?.tabIndex;
    this.type = obj?.type ?? '';
    this.control = obj?.control!;
    this.label = obj?.label;
    this.help = obj?.help;
    this.errors = obj?.errors;
  }
}

export class EoCustomControlConfig extends FormControlConfig {
  override type = 'custom';

  constructor();
  constructor(obj: IFormControlConfig);
  constructor(obj?: IFormControlConfig) {
    super(obj!);
  }
}

export interface IFormConfig {
  config: IFormControlConfig[];
}

export class FormConfig implements IFormConfig {
  config: FormControlConfig[];

  // public static getFormFromConfig(config: FormConfig, fB: FormBuilder) {}

  public getFormGroup(): FormGroup {
    let formGroup: any = {};
    this.config.forEach((c) => (formGroup[c.name] = c.control));
    return formGroup;
  }

  public getFormControl(formControlName: string): FormControl | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.control ?? undefined
    );
  }

  public getHelp(formControlName: string): string | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.help ?? undefined
    );
  }

  public getErrors(formControlName: string): IFormValidationError | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.errors ?? undefined
    );
  }

  constructor();
  constructor(obj: IFormConfig);
  constructor(obj?: IFormConfig) {
    this.config = obj?.config ?? [];
  }
}

//
